// services/employeeService.js
import apiClient from '../utils/apiClient';

/**
 * Fetch active employees for calendar resources.
 * Response shape: [{ id, title, role }]
 */
export const fetchEmployees = async () => {
  try {
    console.log('[EmployeeService] Fetching employees (active only)');
    const res = await apiClient.get('/employees', { withCredentials: true });
    return res.data;
  } catch (error) {
    console.error('[EmployeeService] ❌ Failed to fetch employees:', error);
    throw error;
  }
};
